/**
 * A random v4 UUID. `crypto.randomUUID` exists only from Chrome 92 / Safari 15.4 and only in a
 * secure context; an older browser threw from the consent bar (MUSIC24-WEB-8). The fallback builds
 * the same format from `crypto.getRandomValues`, which every supported browser has.
 */
export const randomUuid = (
  cryptoApi: Pick<Crypto, 'getRandomValues'> & Partial<Pick<Crypto, 'randomUUID'>> = window.crypto
): string => {
  if (typeof cryptoApi.randomUUID === 'function') {
    return cryptoApi.randomUUID();
  }
  const bytes = new Uint8Array(16);
  cryptoApi.getRandomValues(bytes);
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  // RFC 9562: version 4 in the 13th hex digit, variant 10 (8, 9, a or b) in the 17th.
  const variant = ((bytes[8] ?? 0) % 4) + 8;
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-4${hex.slice(13, 16)}-${variant.toString(16)}${hex.slice(17, 20)}-${hex.slice(20)}`;
};
